import { calcularRentaArrendamientoPuro } from "@helpers/funciones";

const IVA_PCT = 16;
export const SEMANAS_POR_MES = 52 / 12;

/**
 * Unidad de WuWei y reglas de su arrendamiento puro (`WW_AUTOS` de `wuwei-screens.jsx` y "Reglas WuWei" del
 * prototipo). La usan el cotizador (`CotizadorWuWei`) y la pre-oferta (`OfertaWuWei`).
 * TODO: datos del prototipo mientras no existan el catálogo de unidades ni las reglas de WuWei; al tenerlos, solo
 * cambia esta constante.
 */
export const AUTO_WUWEI = {
  marca: "BYD",
  modelo: "Dolphin Mini Plus",
  // Modelo y versión por separado para el leasing (`details`): "Dolphin Mini" versión "Plus".
  modeloLeasing: "Dolphin Mini",
  version: "Plus",
  anio: 2026,
  tipo: "Eléctrico",
  autonomia: "380 km",
  /** Precio de lista, IVA incluido. */
  precio: 415800,
  plazoMeses: 36,
  /** % anual sin IVA. */
  tasaAnual: 19.51,
  /** % del precio; es la opción a compra al final del contrato. */
  residualPct: 20,
  // Servicios incluidos en la renta, con IVA.
  /** Seguro todo riesgo de uso en plataforma: % anual del precio. */
  seguroAnualPct: 10,
  /** Mantenimiento preventivo de un eléctrico a ~60,000 km al año, MXN / año. */
  mantenimientoAnual: 18000,
  /** GPS y telemetría, MXN / mes. */
  gpsMensual: 800,
  /** Gestión vehicular (placas, verificación, trámites): % anual del precio. */
  administracionAnualPct: 4.5,
};

/**
 * Renta semanal de arrendamiento puro sin enganche: el financiamiento es el PMT semanal del valor sin IVA con el
 * residual como valor final, y encima van los servicios y la administración, de su costo anual o mensual a semanas.
 * La renta en garantía es un mes de financiamiento y se devuelve al final del contrato.
 */
const semanas = Math.round(AUTO_WUWEI.plazoMeses * SEMANAS_POR_MES);
const financiamiento = Math.round(
  calcularRentaArrendamientoPuro({
    valor: AUTO_WUWEI.precio / (1 + IVA_PCT / 100),
    enganchePct: 0,
    plazo: semanas,
    tasaAnual: AUTO_WUWEI.tasaAnual,
    residualPct: AUTO_WUWEI.residualPct,
    ivaPct: IVA_PCT,
    diasPeriodo: 7,
  }).rentaConIva,
);
const servicios = Math.round(
  ((AUTO_WUWEI.precio * AUTO_WUWEI.seguroAnualPct) / 100 + AUTO_WUWEI.mantenimientoAnual) / 52 +
    AUTO_WUWEI.gpsMensual / SEMANAS_POR_MES,
);
const administracion = Math.round((AUTO_WUWEI.precio * AUTO_WUWEI.administracionAnualPct) / 100 / 52);

export const RENTA_WUWEI = {
  semanal: financiamiento + servicios + administracion,
  /** Plazo en semanas (36 meses = 156 semanas). */
  semanas,
  garantia: Math.round(financiamiento * SEMANAS_POR_MES),
  desglose: [
    { label: "Financiamiento", value: financiamiento },
    { label: "Seguro + Mant. + GPS", value: servicios },
    { label: "Administración", value: administracion },
  ],
};
